import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { MOBILE } from '../../../utils/constants';
import Select, { type SelectProps } from '@atlaskit/select';

interface Props extends SelectProps<any, boolean> {
  id: string;
  label: string;
  minWidth?: number;
  menuMinWidth?: number;
}

export const FilterSelect = ({ id, label, minWidth = 120, menuMinWidth, ...selectProps }: Props) => {
  return (
    <div css={selectGroupStyles}>
      <label htmlFor={id} css={selectLabelStyles}>
        {label}
      </label>
      <Select
        inputId={id}
        {...selectProps}
        styles={{
          container: (base) => ({ ...base, minWidth }),
          ...(menuMinWidth && { menu: (base) => ({ ...base, minWidth: menuMinWidth }) }),
        }}
      />
    </div>
  );
};

const selectGroupStyles = css({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
});

const selectLabelStyles = css({
  fontSize: '14px',
  color: token('color.text.subtlest', '#6B778C'),
  fontWeight: token('font.weight.medium', '500'),
  marginBottom: token('space.050', '4px'),
  marginLeft: token('space.025', '2px'),
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '13px',
    marginLeft: 0,
  },
});
